/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ServiceRapportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getServiceRapportUrl
   */
  static readonly GetServiceRapportUrlPath = '/api/v1/ServiceRapport/GetServiceRapportUrl/{serviceordreNo}/{rapportId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceRapportUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceRapportUrl$Response(params: {
    serviceordreNo: number;
    rapportId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceRapportService.GetServiceRapportUrlPath, 'get');
    if (params) {
      rb.path('serviceordreNo', params.serviceordreNo, {});
      rb.path('rapportId', params.rapportId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceRapportUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceRapportUrl(params: {
    serviceordreNo: number;
    rapportId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<string> {

    return this.getServiceRapportUrl$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
